import { useTranslation } from "react-i18next";
import { BarChart3, CalendarCheck } from "lucide-react";
import { cn } from "../../lib/utils";
import { PayrollFilters } from "./PayrollFilters";
import { ReportDetailsCard } from "./ReportDetailsCard";

const PILL = "flex items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-bold transition-all duration-300";

// تبويب التقارير: تبويبان مباشران بلا خلفية، ثم فترة واحدة تحكم التقرير المختار.
export const ReportsTab = ({ filters, onFiltersChange, kind, onKindChange }) => {
  const { t } = useTranslation();
  const tabs = [
    { key: "salary", label: t("salaryReport.monthly"), icon: BarChart3 },
    { key: "attendance", label: t("attendanceReport.monthly"), icon: CalendarCheck },
  ];

  return (
    <div className="grid gap-6" data-testid="reports-tab">
      <div className="flex flex-wrap items-center gap-3">
        {tabs.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            type="button"
            data-testid={`report-kind-tabs-${key}`}
            aria-selected={key === kind}
            onClick={() => onKindChange(key)}
            className={cn(PILL, key === kind
              ? "bg-primary text-primary-foreground shadow-neu-in"
              : "text-muted-foreground shadow-neu-sm hover:-translate-y-0.5 hover:text-primary")}
          >
            <Icon className="h-4 w-4" /> {label}
          </button>
        ))}
      </div>
      <PayrollFilters value={filters} onChange={onFiltersChange} />
      <ReportDetailsCard filters={filters} kind={kind} />
    </div>
  );
};
